import { render, staticRenderFns } from "./DataTag.vue?vue&type=template&id=5ef9d372&scoped=true&"
import script from "./DataTag.vue?vue&type=script&lang=js&"
export * from "./DataTag.vue?vue&type=script&lang=js&"
import style0 from "./DataTag.vue?vue&type=style&index=0&id=5ef9d372&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef9d372",
  null
  
)

export default component.exports